<style scoped>
.column {
  float: left;
  width: 50%;
}
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
  }
}
.heart-button span {
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
  padding-top: 50px;
  font-size: 2rem;
  text-transform: uppercase;
  font-weight: bold;
}
a.heart-button:link {
  text-decoration: none;
}

a.heart-button:visited {
  text-decoration: none;
}
</style>

<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .3), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <div style="max-width: 600px;">
          <img
            :src="require('@/assets/covers/marianne-title.png')"
            width="100%"
            style="filter: invert(100%)"
          />

          <div style="font-size: 24px; margin-bottom: 40px">
            <p>A brain unfit for human habitation.</p>
            <p>A neighbor boy with a jaw to inspire bad poetry.</p>
            <p>
              And hidden in the closet, a secret Goth dress for those days when
              she wants to feel dead on the outside, too… meet Marianne.
            </p>
          </div>
          <div
            style="
              display: flex;
              width: 100%;
              flex-wrap: wrap;
              justify-content: center;
            "
          >
            <a
              href="https://www.amazon.com/dp/B08RWNXSXJ"
              target="_blank"
              class="heart-button"
              style="padding-bottom: 10px"
            >
              <v-img
                :src="require('@/assets/heart-button.png')"
                width="240"
                height="160"
                contain
                ><span>Buy Now</span></v-img
              >
            </a>
            <base-btn
              :to="{ name: 'Marianne' }"
              :ripple="false"
              class="pa-1"
              height="auto"
              text
              >read the sample</base-btn
            >
          </div>
        </div>
        <div
          style="
            display: flex;
            max-width: 600px;
            flex-wrap: wrap;
            justify-content: center;
          "
        >
          <a href="https://www.amazon.com/dp/B08RWNXSXJ">
            <img
              :src="require('@/assets/covers/marianne-book.png')"
              width="100%"
            />
          </a>
        </div>
        <!-- <v-responsive class="d-flex align-top" height="100%" width="100%">
          <div class="column">
            <v-img
              :src="require('@/assets/covers/marianne-title.png')"
              max-width="600"
              width="100%"
              style="filter: invert(100%);"
            />

            <div style="font-size: 24px; margin-bottom: 40px;">
              <p>A brain unfit for human habitation.</p>
              <p>A neighbor boy with a jaw to inspire bad poetry.</p>
              <p>And hidden in the closet, a secret Goth dress for those days when she wants to feel dead on the outside, too… meet Marianne.</p>
            </div>

            <div
              :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
              class="d-flex flex-wrap"
            >
              <a href="https://www.amazon.com/dp/B08RWNXSXJ" target="_blank" class="heart-button">
                <v-img :src="require('@/assets/heart-button.png')" width="240" height="160" contain><span>Buy Now</span></v-img>
              </a>
              <span class="font-weight-bold ml-6 mr-4 my-4">or</span>
              <base-btn
                :to="{ name: 'Marianne' }"
                :ripple="false"
                class="pa-1"
                height="auto"
                text
              >read the sample</base-btn>
              <span class="font-weight-bold ml-6 mr-4 my-4">&nbsp;</span>
            </div>
          </div>

          <a href="https://www.amazon.com/dp/B08RWNXSXJ">
            <base-img
              :src="require('@/assets/covers/marianne-book.png')"
              class="column"
              contain
              max-width="600"
              href="https://www.amazon.com/dp/B08RWNXSXJ"
            />
          </a>
        </v-responsive> -->
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>
